import './LoadingSpinner.css';
interface Props {
  light?: boolean;
}

function LoadingSpinner({ light }: Props): JSX.Element {
  return (
    <div
      className={`LoadingSpinner ${light ? 'LoadingSpinnerLight' : 'LoadingSpinnerDark'}`}
    />
  );
}

export default LoadingSpinner;
